// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundProjectionScreenOutlinedSvg from "@fishx/icons-svg/es/asn/FundProjectionScreenOutlined";
import FishxIcon from '../components/FishxIcon';

var FundProjectionScreenOutlined = function FundProjectionScreenOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundProjectionScreenOutlinedSvg
  }));
};

FundProjectionScreenOutlined.displayName = 'FundProjectionScreenOutlined';
export default React.forwardRef(FundProjectionScreenOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FundProjectionScreenOutlined.js
// module id = 2845
// module chunks = 0